(function () {
    'use strict';

    angular.module('app')
        .factory('promoModule', PromoModule);

    PromoModule.$inject = ['$http'];

    function PromoModule($http) {
        const factory = this;

        factory.createAllBanners = createAllBanners;
        factory.createFacebookBannerConcert = createFacebookBannerConcert;
        factory.createInstagramPostConcert = createInstagramPostConcert;
        factory.createInstagramStoryConcert = createInstagramStoryConcert;
        factory.getUrlConcert = getUrlConcert;

        const image_types = {
            'facebook': 1,
            'instagram_post': 2,
            'instagram_story': 3
        };

        function createAllBanners(concert, options) {
            const concertImageUrl = getUrlConcert(concert);
            Promise.allSettled([
                createFacebookBannerConcert(concertImageUrl, concert, options?.force ?? false),
                createInstagramPostConcert(concertImageUrl, concert, options?.force ?? false),
                createInstagramStoryConcert(concertImageUrl, concert, options?.force ?? false)
            ]).then((results) => {
                let data = {};
                if (results[0].status === 'fulfilled') data['facebook'] = results[0].value;
                if (results[1].status === 'fulfilled') data['instagram_post'] = results[1].value;
                if (results[2].status === 'fulfilled') data['instagram_story'] = results[2].value;
                if (Object.keys(data).length === 0) return;
                $http.put('api/concerts/' + (options?.concert_slug ?? concert.concert_slug) + '/promo', data);
            });
        }

        function createFacebookBannerConcert(url, concert, force) {
            if (!force && concert.concert_promo_images.some(image => image.image_type === image_types['facebook'])) {
                return Promise.reject('already exists');
            }
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1200;
                    canvas.height = 630;

                    const ctx = canvas.getContext("2d");
                    const scaledHeight = 1200 * image.height / image.width;
                    ctx.drawImage(image, 0, -((scaledHeight - canvas.height) / 2), 1200, 1200 * image.height / image.width);

                    const greyOverlay = ctx.createLinearGradient(0, 0, 0, 630);
                    greyOverlay.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
                    greyOverlay.addColorStop(1, 'rgba(0, 0, 0, 0.6)');
                    ctx.fillStyle = greyOverlay;
                    ctx.fillRect(0, 0, 1200, 630);

                    ctx.font = "70px Euclid-semibold";
                    ctx.fillStyle = "white";

                    const numLines = getLines(ctx, concert.concert_name, 900);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 334);
                        ctx.fillText(numLines[1], 62, 404);
                    } else {
                        ctx.fillText(concert.concert_name, 62, 404);
                    }

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(concert.concert_city, 62, 488);

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(moment(concert.concert_start_time).format('D. MMMM YYYY'), 62, 564);

                    var img = document.createElement('IMG');

                    img.onload = function () {
                        var x = 1200 - 370
                        var y = 630 - 205
                        ctx.drawImage(img, x, y, 370, 185);
                        ctx.translate(1019, 541);
                        resolve(canvas.toDataURL("image/jpeg"));
                    }

                    img.src = '/img/BMC-logo-transparent.svg';

                };
                image.src = url;
            });
        }

        function createInstagramPostConcert(url, concert, force) {
            if (!force && concert.concert_promo_images.some(image => image.image_type === image_types['instagram_post'])) {
                return Promise.reject('already exists');
            }
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1080;
                    canvas.height = 1080;

                    const ctx = canvas.getContext("2d");
                    const scaledWidth = image.width * (1080 / image.height);
                    ctx.drawImage(image, -((scaledWidth - 1080) / 2), 0, scaledWidth, 1080);

                    const greyOverlay = ctx.createLinearGradient(0, 0, 0, 1080);
                    greyOverlay.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
                    greyOverlay.addColorStop(1, 'rgba(0, 0, 0, 0.6)');
                    ctx.fillStyle = greyOverlay;
                    ctx.fillRect(0, 0, 1080, 1080);

                    ctx.font = "70px Euclid-semibold";
                    ctx.fillStyle = "white";

                    const topMargin = 440;

                    const numLines = getLines(ctx, concert.concert_name, 900);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 334 + topMargin);
                        ctx.fillText(numLines[1], 62, 404 + topMargin);
                    } else {
                        ctx.fillText(concert.concert_name, 62, 404 + topMargin);
                    }

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(concert.concert_city, 62, 488 + topMargin);

                    ctx.font = "60px Euclid-medium";
                    ctx.fillText(moment(concert.concert_start_time).format('D. MMMM YYYY'), 62, 564 + topMargin);


                    var img = document.createElement('IMG');

                    img.onload = function () {
                        var x = 1080 - 370
                        var y = 1080 - 215
                        ctx.drawImage(img, x, y, 370, 185);
                        ctx.translate(900, 541 + topMargin);
                        resolve(canvas.toDataURL("image/jpeg"));
                    }

                    img.src = '/img/BMC-logo-transparent.svg';

                };
                image.src = url;
            });
        }

        function createInstagramStoryConcert(url, concert, force) {
            if (!force && concert.concert_promo_images.some(image => image.image_type === image_types['instagram_story'])) {
                return Promise.reject('already exists');
            }
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = 1080;
                    canvas.height = 1920;

                    const ctx = canvas.getContext("2d");
                    const scaledWidth = image.width * (1920 / image.height);
                    ctx.drawImage(image, -((scaledWidth - 1080) / 2), 0, scaledWidth, 1920);

                    const greyOverlay = ctx.createLinearGradient(0, 0, 0, 1920);
                    greyOverlay.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
                    greyOverlay.addColorStop(1, 'rgba(0, 0, 0, 0.6)');
                    ctx.fillStyle = greyOverlay;
                    ctx.fillRect(0, 0, 1080, 1920);

                    const topMargin = 886;

                    ctx.font = "90px Euclid-semibold";
                    ctx.fillStyle = "white";

                    let numLines = getLines(ctx, concert.concert_name, 800);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 330 + topMargin);
                        ctx.fillText(numLines[1], 62, 420 + topMargin);
                    } else if (numLines.length == 3) {
                        ctx.fillText(numLines[0], 62, 240 + topMargin);
                        ctx.fillText(numLines[1], 62, 330 + topMargin);
                        ctx.fillText(numLines[2], 62, 420 + topMargin);
                    } else {
                        ctx.fillText(concert.concert_name, 62, 420 + topMargin);
                    }

                    ctx.font = "80px Euclid-medium";
                    ctx.fillText(moment(concert.concert_start_time).format('D. MMMM YYYY'), 62, 534 + topMargin);

                    numLines = getLines(ctx, concert.concert_city, 800);
                    if (numLines.length == 2) {
                        ctx.fillText(numLines[0], 62, 634 + topMargin);
                        ctx.fillText(numLines[1], 62, 714 + topMargin);
                    } else if (numLines.length == 3) {
                        ctx.fillText(numLines[0], 62, 634 + topMargin);
                        ctx.fillText(numLines[1], 62, 714 + topMargin);
                        ctx.fillText(numLines[2], 62, 794 + topMargin);
                    } else {
                        ctx.fillText(concert.concert_city, 62, 634 + topMargin);
                    }

                    var img = document.createElement('IMG');

                    img.onload = function () {
                        var x = 10
                        var y = 1920 - 185
                        ctx.drawImage(img, x, y, 370, 185);
                        ctx.translate(62, 930 + topMargin);
                        resolve(canvas.toDataURL("image/jpeg"));
                    }

                    img.src = '/img/BMC-logo-transparent.svg';
                };
                image.src = url;
            });
        }

        function getUrlConcert(concert) {
            return '/uploads/' + (concert.band_image_hash ? 'bands/' + concert.band.band_slug + '/' + concert.band_image_hash : 'concerts/' + concert.concert_slug + '/1') + '_xl.jpeg';
        }

        function getLines(ctx, text, maxWidth) {
            const words = text.split(" ");
            const lines = [];
            let currentLine = words[0];

            for (let i = 1; i < words.length; i++) {
                const word = words[i];
                const width = ctx.measureText(currentLine + " " + word).width;
                if (width < maxWidth) {
                    currentLine += " " + word;
                } else {
                    lines.push(currentLine);
                    currentLine = word;
                }
            }
            lines.push(currentLine);
            return lines;
        }

        return factory;
    }
})();
